import { AuthContainer, AuthenticatorProvider } from "@pharaday/auth";
import { useMutation } from "@tanstack/react-query";

export const useRequestMagicLink = () => {
  return useMutation({
    mutationFn: (email: string) => AuthContainer.get(AuthenticatorProvider).requestMagicLink(email),
  });
};
